export default { // 如果需要改动这个文件的内容，请考虑影响范围。
  expressTypeList: [
    {
      id: 1,
      name: '冷链药品',
    },
    {
      id: 2,
      name: '非冷链药品',
    },
  ],
  getNormalGoodsTypes: [ // 采购计划新建，编辑采用的商品类型的数据
    {
      value: 1,
      name: '药品',
    },
    {
      value: 2,
      name: '医疗器械',
    },
    {
      value: 3,
      name: '中药饮片',
    },
    {
      value: 4,
      name: '食品/其他',
    },
  ],
  orderStatus: [ // 订单状态
    {
      id: 1,
      name: '待完成',
    },
    {
      id: 2,
      name: '已完成',
    },
    {
      id: 3,
      name: '取消中',
    },
    {
      id: 4,
      name: '已取消',
    },
    {
      id: 6,
      name: '部分退货',
    },
    {
      id: 7,
      name: '全部退货',
    },
  ],
  orderType: [ // 订单类型
    {
      id: 1,
      name: '店销',
    },
    {
      id: 2,
      name: '配送',
    },
  ],
  proceedsStatus: [ // 收款状态
    {
      id: 1,
      name: '已收款',
    },
    {
      id: 2,
      name: '部分收款',
    },
    {
      id: 3,
      name: '未收款',
    },
  ],
  expressStatus: [ // 物流状态
    {
      id: 1,
      name: '已发货',
    },
    {
      id: 2,
      name: '已收货',
    },
    {
      id: 3,
      name: '待发货',
    },
  ],
  isReceivedList: [ // 签收状态列表
    {
      id: 1,
      name: '未签收',
    },
    {
      id: 2,
      name: '已签收',
    },
  ],
  procurementFormList: [
    {
      id: 1,
      name: '日常采购',
    },
    {
      id: 2,
      name: '月末采购',
    },
    {
      id: 3,
      name: '季度末采购',
    },
  ],
  adjustmentReasonList: [
    {
      id: 1,
      name: '官方调价',
    },
    {
      id: 2,
      name: '活动促销',
    },
  ],
  periodForbidSaleDays: {
    value: 7,
    name: '首营时间默认值',
  },
  booleanList: [
    {
      id: 1,
      name: '是',
    },
    {
      id: 2,
      name: '否',
    },
  ],
  operatorTypeList: [
    {
      id: 1,
      name: '总部月盘'
    },
    {
      id: 2,
      name: '总部周盘'
    },
    {
      id: 3,
      name: '门店常规盘点'
    },
    {
      id: 4,
      name: '其他'
    },
  ],
  operatorPatternsList: [
    {
      id: 1,
      name: '明盘'
    },
    {
      id: 2,
      name: '暗盘'
    },
  ],
  managementTypeList: [
    {
      id: 1,
      managementType: 1,
      name: '满足条件时必须参加',
    },
    {
      id: 2,
      managementType: 2,
      name: '满足条件时可选参加',
    },
  ],
  statusList: [
    {
      id: '',
      name: '全部',
    },
    {
      id: 1,
      name: '已预约',
    },
    {
      id: 2,
      name: '未预约',
    },
  ],
};
